import { render, staticRenderFns } from "./ForgotPasswordHeader.vue?vue&type=template&id=2dfb971a&scoped=true&"
import script from "./ForgotPasswordHeader.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfb971a",
  null
  
)

export default component.exports